export const DEFAULT_APP_PAGE_SIZE = 200;
export const DATASET_PREVIEW_LIMIT = 100;
export const DEFAULT_VISUALIZATION_LIMIT = 1000;
export const PREVIEW_PANE_HEIGHT = 'beem-preview-pane-height';
export const LOGIN_REDIRECT = 'beem-login-redirect-url';
export const MAINTENANCE_WINDOW_MILLISECONDS = 30 * 60 * 1000;
export const DASHBOARD_MAX_VISIBLE_FILTERS = 5;
/** When this many or fewer widgets fail, show errors directly on each widget. Above this threshold, show the bulk retry modal instead. */
export const DASHBOARD_NUM_ERR_DIRECT_SHOW = 3;
/** Number of automatic retry rounds before surfacing errors to the user (via modal or individual widget errors). */
export const DASHBOARD_MAX_AUTO_RETRY_ROUNDS = 2;
/** When true, use window.location.href for dashboard view/edit navigation to force a full page reload (kills in-flight effects). Set to false to use client-side history.push instead. */
export const FOR_DEV_USE_DASHBOARD_PAGE_RELOAD = true;
